import React from 'react';
import { Title } from '../../elements';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import AssessmentIcon from '@material-ui/icons/Assessment';

import { useStyles } from './styles';
import useAuthContext from '../../hooks/useAuthContext';
import { Button, Card, CardContent, CardHeader, Icon, IconButton, Typography, Container } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

const Dashboard: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Grid container direction="row" className={classes.infoTextBox}>
            {/* Dashboard title */}
            <Grid item container md={6} xs={6} spacing={1}>
              <Grid item>
                <AssessmentIcon color="primary" fontSize="large" />
              </Grid>
              <Grid item>
                <Title>{t('f-vets-dash')}</Title>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="row"
            spacing={4}
            alignContent="stretch"
            alignItems="stretch"
            className={classes.mt2}
          >
            <Grid item md={3} xs={6}>
              <VeterinaryWidgetCard />
            </Grid>
            <Grid item md={3} xs={6}>
              <OrdersWidgetCard />
            </Grid>
            <Grid item md={3} xs={6}>
              <BottlesWidgetCard />
            </Grid>
            <Grid item md={3} xs={6}>
              <LabelsWidgetCard />
            </Grid>
            <Grid item md={3} xs={6}>
              <MockWidgetCard />
            </Grid>
            <Grid item md={3} xs={6}>
              <MockWidgetCard />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboard;

export const WidgetCardTemplate = (props: {
  title: React.ReactNode;
  subheader: React.ReactNode;
  content: React.ReactNode;
  iconName?: string;
}) => {
  const { title, subheader, content, iconName } = props;

  return (
    <Card elevation={1} style={{ height: '100%' }}>
      <Grid container direction="column">
        <CardHeader
          action={
            iconName && (
              <IconButton disabled>
                <Icon color="primary">{iconName}</Icon>
              </IconButton>
            )
          }
          title={title}
          subheader={subheader}
        />
        <CardContent>{content}</CardContent>
      </Grid>
    </Card>
  );
};

export const MockWidgetCard = () => {
  return (
    <WidgetCardTemplate
      title="Feature widget"
      subheader="More features coming soon"
      iconName="construction"
      content={
        <Typography variant="overline" color="textSecondary" component="p" style={{ textAlign: 'center' }}>
          This feature is under development
        </Typography>
      }
    />
  );
};

export const LabelsWidgetCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateToLabels = () => {
    navigate('/vet/labels');
  };

  return (
    <WidgetCardTemplate
      title={t('f-settings-labels')}
      subheader={t('f-settings-labels-inf')}
      content={
        <Button
          startIcon={<Icon>{'sticky_note_2'}</Icon>}
          variant="outlined"
          fullWidth
          size="small"
          color="primary"
          onClick={navigateToLabels}
        >
          {t('f-settings-labels')}
        </Button>
      }
    />
  );
};

export const BottlesWidgetCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateToBottles = () => {
    navigate('/vet/bottles');
  };
  const navigateToSupplies = () => {
    navigate('/vet/medical-supplies');
  };

  return (
    <WidgetCardTemplate
      title={t('f-bottles')}
      subheader={t('f-bottles-inf')}
      content={
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <Button
              startIcon={<Icon>{'medical_services'}</Icon>}
              variant="outlined"
              fullWidth
              size="small"
              color="primary"
              onClick={navigateToSupplies}
            >
              {t('f-supplies')}
            </Button>
          </Grid>

          <Grid item>
            <Button
              startIcon={<Icon>{'medication'}</Icon>}
              variant="outlined"
              fullWidth
              size="small"
              color="primary"
              onClick={navigateToBottles}
            >
              {t('f-bottles-view')}
            </Button>
          </Grid>
        </Grid>
      }
    />
  );
};

export const OrdersWidgetCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateToOrders = () => {
    navigate('/vet/orders');
  };

  return (
    <WidgetCardTemplate
      title={t('f-supp-order-widget-title')}
      subheader={t('f-supp-order-widget-subtitle')}
      iconName="shopping_cart"
      content={
        <Button
          startIcon={<Icon>{'shopping_cart'}</Icon>}
          variant="outlined"
          fullWidth
          size="small"
          color="primary"
          onClick={navigateToOrders}
        >
          {t('f-supp-order-widget-btntext')}
        </Button>
      }
    />
  );
};

export const VeterinaryWidgetCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useAuthContext();

  const navigateToAccount = () => {
    // history('/vet/orders');
    alert('To implement');
  };

  const navigateToLocation = () => {
    navigate(`/veterinary/${state.vetId}`);
  };

  return (
    <WidgetCardTemplate
      title={t('Tenant')}
      subheader={t('Veterinary company information')}
      iconName="medical_services"
      content={
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <Button
              startIcon={<Icon>{'account_box'}</Icon>}
              variant="outlined"
              fullWidth
              disabled
              size="small"
              color="primary"
              onClick={navigateToAccount}
            >
              {t('View profile')}
            </Button>
          </Grid>

          <Grid item>
            <Button
              startIcon={<Icon>{'location_city'}</Icon>}
              variant="outlined"
              fullWidth
              size="small"
              color="primary"
              onClick={navigateToLocation}
            >
              {t('Company overview')}
            </Button>
          </Grid>
        </Grid>
      }
    />
  );
};
